import {useParams} from 'react-router-dom';

import {userReportAPI} from 'features/userReports/api/userReportAPI';

export const usePublicUserReport = () => {
    const {uuid} = useParams();
    const {data, isLoading, isError} = userReportAPI.useGetUserReportViewQuery(uuid ?? '', {skip: !uuid});

    return {data, isLoading, isNotFound: isError || !data};
};

export default usePublicUserReport;
